import React, { useRef, useState } from 'react'
import {
    FaCamera
} from 'react-icons/fa';
import Compressor from 'compressorjs';
import imageUrl from '../../utils/imageUrl';
import axios from '../../utils/axios';
import { toast, ToastContainer } from 'react-toastify';


function Avatar({ img, businessId }) {
    const [image, setImage] = useState(img);
    const [file, setFile] = useState(null);
    const inputRef = useRef();
    const handler = (event) => {
        inputRef.current.click();

    }
    const onImageChange = event => {
        new Compressor(event.target.files[0], {
            quality: 0.2, // 0.6 can also be used, but its not recommended to go below.
            success: (compressedResult) => {
                // compressedResult has the compressed file.
                // Use the compressed file to upload the images to your server.        
                //   setCompressedFile(res)
                console.log('compressed:', compressedResult.size / 1024 / 1024);
                if (event.target.files && event.target.files[0]) {
                    let img = compressedResult;
                    var imageURL = URL.createObjectURL(img);
                    setImage(imageURL);
                    setFile(img);
                    // console.log(file)
                    // other comment new new new
                    const formData = new FormData();
                    formData.append("file", compressedResult);
                    axios.put(
                        "business/updateBusinessById/" + businessId, formData, {
                        headers: {
                            // Multer only parses "multipart/form-data" requests
                            "Access-Control-Allow-Origin": '*',
                            'Content-Type': 'multipart/form-data',
                        }
                    })
                        .then((response) => {
                            // console.log(response);
                            axios.get(`business/GetBusinessById/${businessId}`).then((res) => {
                                res.data.Data.Image = `${imageUrl}${res.data.Data.Image}`;
                                window.sessionStorage.setItem('business', JSON.stringify(res.data.Data));
                            }).catch((err) => {
                                    console.log('Error');
                                })
                            // var bData = window.sessionStorage.getItem('business');
                            // bData = JSON.parse(bData);
                            // bData.Image = imageURL;

                            // window.sessionStorage.setItem('business', JSON.stringify(bData));
                            // setTimeout(() => {
                            toast("Image updated successfully");
                            //     Window.location.reload();
                            // }, 1000);
                        })
                        .catch((e) => {
                            console.log(e)
                            toast("Image could not be updated!");
                        });
                }
            },
        });

    };
    return (
        <div className='card avatar-card'>
            <div className='card-body'>
                <img src={image} className='w-100' />
            </div>
            <div className='d-none'>
                <input type='file' ref={inputRef} onChange={onImageChange} />
            </div>
            <button className='btn btn-cta' onClick={handler}>
                <FaCamera className='icon' />
            </button>
        </div>
    )
}

Avatar.defaultProps = {
    img: 'https://via.placeholder.com/150'
}

export default Avatar
